<template>
  <div>
    <base-material-card
      color="indigo"
      icon="mdi-vuetify"
      inline
    >
      <v-card-title>
        <h3>{{ title }}</h3>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-container class="py-0">
            <v-row>
              <v-col

                cols="12"
                md="2"
              >
                <span v-if="form.contract">Договор: <a @click="$router.push('/contract/list?id=' + form.contract)">{{ format_contract(form.contract_item.number, form.contract_item.date) }}</a></span>
              </v-col>
              <v-col

                cols="12"
                md="3"
              >
                <span v-if="form.client">{{ form.client_item.surname }} {{ form.client_item.name }} {{ form.client_item.patronymic }}</span>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.user"
                  :disabled="view"
                  :items="select.user"
                  label="Исполнитель"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="form.phone"
                  :disabled="view"
                  label="Телефон"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.email"
                  :disabled="view"
                  label="E-mail"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.type"
                  :disabled="view"
                  :items="select.type"
                  label="Тип"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="form.state"
                  :disabled="view"
                  :items="select.state"
                  label="Статус"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.theme"
                  :disabled="view"
                  label="Тема"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.text"
                  :disabled="view"
                  label="Описание"
                  required
                />
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="form.date"
                  :disabled="view"
                  label="Дата"
                  type="date"
                  required
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="form.time"
                  :disabled="view"
                  label="Время"
                  type="time"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="6">
            <v-btn
              :disabled="loader.show"
              color="secondary"
              min-width="250"
              @click="$emit('close')"
            >
              Назад
            </v-btn>
            <v-btn
              v-if="!view && ((create && $store.state.access[3][5]) || (change && ($store.state.access[3][3] || $store.state.access[3][4] && form.creator && form.creator.id == $store.state.user.id)))"
              isabled="loader.show"
              color="primary"
              min-width="250"
              @click="event_save"
            >
              Сохранить
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="text-right"
          >
            <v-btn
              v-if="form.id &&form.state == 1"
              :disabled="loader.show"
              color="success"
              min-width="250"
              @click="close_event(false)"
            >
              Завершить
            </v-btn>
            <v-btn
              v-if="form.id &&form.state == 1"
              :disabled="loader.show"
              color="primary"
              min-width="250"
              @click="close_event(true)"
            >
              Завершить (и создать новую)
            </v-btn>
            <v-btn
              v-if="form.id && form.state == 1"
              :disabled="loader.show"
              color="error"
              min-width="250"
              @click="cancel_event"
            >
              Отклонить
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </base-material-card>
  </div>
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  export default {
    name: 'EventForm',
    props: ['create', 'view', 'change', 'data', 'show'],
    data () {
      return {
        loader: {
          show: false,
        },
        title: '',
        form: {
          id: '',
          theme: '',
          text: '',
          date: '',
          time: '',
          contract: '',
          contract_item: {},
          state: 0,
          type: 0,
          phone: '',
          email: '',
          client: '',
          client_item: {},
          user: '',
          user_item: {},
        },
        select: {
          state: [
            { value: 1, text: 'Новый' },
            { value: 2, text: 'Завершен' },
            { value: 3, text: 'Отменен' },
          ],
          type: [],
          user: [],
        },
      }
    },
    watch: {
      show: function () {
        if (this.show) {
          this.suggestion = false
          console.log(this.show, 'this.show')
          if (this.create) this.title = 'Создание'
          if (this.change) this.title = 'Изменение'
          if (this.view) this.title = 'Просмотр'
          this.load()
        }
      },
    },
    mounted: function () {
      for (const x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }

      this.axios.post('/api/user/get/', { deleted: false })
        .then(response => {
          if (!response.data.error) {
            for (const x in response.data.data) {
              this.select.user.push({
                value: response.data.data[x].id,
                text: (response.data.data[x].surname ? response.data.data[x].surname + ' ' : '') + response.data.data[x].name || '-' + (response.data.data[x].patronymic ? ' ' + response.data.data[x].patronymic : ''),
              })
            }
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.load()
    },
    methods: {
      close_event: function (create_new) {
        this.form.state = 2
        this.event_save(create_new)
        if (create_new) {
          this.form = {
            id: '',
            theme: '',
            text: '',
            date: moment().format('YYYY-MM-DD'),
            time: '12:00',
            contract: this.form.contract,
            contract_item: this.form.contract_item,
            state: 0,
            type: 0,
            phone: '',
            email: '',
            client: this.form.client,
            client_item: this.form.client_item,
            user: this.form.user,
            user_item: this.form.user_item,
          }
          if (this.form.client_item && this.form.client_item.phone && !this.form.phone) {
            this.form.phone = this.form.client_item.phone
          }
          if (this.form.client_item && this.form.client_item.email && !this.form.email) {
            this.form.email = this.form.client_item.email
          }
          this.create = true
          this.change = false
        }
      },
      cancel_event: function () {
        this.form.state = 3
        this.event_save()
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      load: function () {
        if (this.data) {
          this.data.time = this.data.time || '12:00'
          this.form.id = this.data.id
          this.form.theme = this.data.theme
          this.form.text = this.data.text
          this.form.date = moment(this.data.date).format('YYYY-MM-DD')
          this.form.time = String(this.data.time).substring(0, 5)
          this.form.contract = this.data.contract
          this.form.contract_item = this.data.contract_item || {}
          this.form.state = this.data.state
          this.form.type = this.data.type
          this.form.phone = this.data.phone
          this.form.email = this.data.email
          this.form.client = this.data.client
          this.form.client_item = this.data.client_item || {}
          this.form.user = this.data.user
          this.form.user_item = this.data.user_item
          if (this.form.client_item && this.form.client_item.phone && !this.form.phone) {
            this.form.phone = this.form.client_item.phone
          }
          if (this.form.client_item && this.form.client_item.email && !this.form.email) {
            this.form.email = this.form.client_item.email
          }
          this.form.creator = this.data.creator
          this.form.place = this.data.place
          this.form.device = this.data.device
          this.form.client = this.data.client
        } else {
          this.form = {
            id: '',
            theme: '',
            text: '',
            date: moment().format('YYYY-MM-DD'),
            time: '12:00',
            contract: '',
            contract_item: {},
            state: 0,
            type: 0,
            phone: '',
            email: '',
            client: '',
            client_item: {},
            user: '',
            user_item: {},
          }
        }
        this.form.time = this.form.time || '12:00'
        this.form.date = this.form.date || moment()
      },
      event_save: function (stay) {
        this.form.time = this.form.time || '12:00'
        this.form.date = this.form.date || moment()
        if (!this.form.id) {
          this.$axios.post('/api/event/create/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$emit('close', response.data.data)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else {
          this.$axios.post('/api/event/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                if (!stay) this.$emit('close', response.data.data)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        }
      },
    },
  }
</script>
